import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface UIState {
	contactModalOpen: boolean
	contactDefaultSubject: string | null
	mobileMenuOpen: boolean
	cookieConsentAccepted: boolean | null
	language: "pt" | "en"
}

const initialState: UIState = {
	contactModalOpen: false,
	contactDefaultSubject: null,
	mobileMenuOpen: false,
	cookieConsentAccepted: null,
	language: "en"
}

const uiSlice = createSlice({
	name: "ui",
	initialState,
	reducers: {
		openContactModal: (state, action: PayloadAction<string | undefined>) => {
			state.contactModalOpen = true
			state.contactDefaultSubject = action.payload || null
		},
		closeContactModal: state => {
			state.contactModalOpen = false
			state.contactDefaultSubject = null
		},
		toggleMobileMenu: state => {
			state.mobileMenuOpen = !state.mobileMenuOpen
		},
		closeMobileMenu: state => {
			state.mobileMenuOpen = false
		},
		setCookieConsent: (state, action: PayloadAction<boolean>) => {
			state.cookieConsentAccepted = action.payload
		},
		setLanguage: (state, action: PayloadAction<"pt" | "en">) => {
			state.language = action.payload
		}
	}
})

export const {
	openContactModal,
	closeContactModal,
	toggleMobileMenu,
	closeMobileMenu,
	setCookieConsent,
	setLanguage
} = uiSlice.actions

export default uiSlice.reducer
